<template>
  <div class="view-financial-data">
    <h5 class="text-semibold pb-5">Dados Financeiros</h5>

    <div
      v-if="bankAccounts.length"
      class="d-flex p-3 rounded-16 mb-7 bg-4 mt-5 gap-2"
    >
      <bp-icon icon="fa-regular fa-circle-exclamation" class="text-dark" />
      <div class="d-flex flex-column">
        <div>Atenção</div>
        <span class="text-dark-40 fs-12">
          Sua conta está habilitada para solicitar saque em conta bancária
          {{ accountType }}. Caso deseje solicitar saque em uma conta bancária
          {{ oppositeAccountType }}, altere a Natureza do Negócio em
          <router-link :to="{ name: 'user-personal-data' }" class="link">
            Dados Pessoais
          </router-link>
        </span>
      </div>
    </div>

    <div class="row justify-content-between align-items-center bg-2 py-2 mb-3">
      <div class="col-2">
        <snow-button
          text="Nova conta bancária"
          variant="borderless"
          icon="ph ph-plus"
          size="sm"
          @click="$router.push({ name: 'new-bank-account' })"
        />
      </div>
      <div class="col-3">
        <bp-input
          v-model="search"
          preIcon="ph ph-magnifying-glass"
          placeholder="Pesquisar"
          size="sm"
          :delay="500"
          @change="dispatch"
        />
      </div>
    </div>

    <div v-if="loading" class="text-center mt-5">
      <b-spinner variant="primary" />
    </div>

    <snow-data-table v-else :data="bankAccounts" :columns="columns">
      <template #no-content-actions>
        <div class="d-flex justify-content-center">
          <snow-button
            icon="fa-regular fa-plus"
            text="Adicionar uma conta bancária"
            @click="
              () => {
                $router.push({ name: 'new-bank-account' });
              }
            "
          />
        </div>
      </template>
    </snow-data-table>
  </div>
</template>
<script>
import SnowDataTable from "@/components/snow-ui/dataTable/SnowDataTable.vue";
import { clearObject, isValidCNPJ } from "@/functions/helpers";
import { mapState } from "vuex";

export default {
  components: {
    SnowDataTable
  },
  data() {
    return {
      search: "",
      modal: false,
      loading: false
    };
  },
  computed: {
    ...mapState("financial", ["bankAccounts", "banksList"]),
    ...mapState("user", ["user"]),
    accountType() {
      return !this.user.company.document ||
        isValidCNPJ(this.user.company.document)
        ? "PJ"
        : "PF";
    },
    oppositeAccountType() {
      return this.accountType == "PJ" ? "PF" : "PJ";
    },
    columns() {
      return [
        {
          name: "Titular",
          field: "owner_account"
        },
        {
          name: "Banco",
          field: "bank",
          transform: this.getBankName
        },
        {
          name: "Agência",
          field: "agency",
          transform: (_, item) => `${item.agency}-${item.agency_vd}`
        },
        {
          name: "Conta",
          field: "number_account",
          transform: (_, item) =>
            `${item.number_account}-${item.number_account_vd}`
        },
        {
          name: "Tipo de Conta",
          field: "type_account",
          transform: v => (v == 1 ? "Conta Corrente" : "Conta Poupança")
        },
        {
          name: "Natureza",
          field: "type",
          transform: this.getDescType
        },
        {
          name: "Status",
          field: "status",
          transform: this.formatStatus,
          color: v =>
            ({
              approved: "green",
              deny: "negative",
              in_analysis: "alert"
            }[v]),
          type: "tag"
        }
      ];
    }
  },
  methods: {
    getBankName(id) {
      return this.banksList.find(item => item.id == id)?.long_name;
    },
    getDescType(val) {
      return val == "pf" ? "Pessoa Física" : "Pessoa Jurídica";
    },
    formatStatus(val) {
      const options = {
        in_analysis: "Em análise",
        approved: "Aprovado",
        deny: "Negado",
        in_review: "Em revisão",
        reject: "Rejeitada"
      };
      return options[val] || val;
    },

    dispatch() {
      this.loading = true;
      this.$store
        .dispatch(
          "financial/getBankAccounts",
          clearObject({
            search: this.search
          })
        )
        .catch(() => {
          this.$message.error("Erro ao carregar contas bancárias");
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  mounted() {
    this.$store.dispatch("financial/getBanksList");
    this.dispatch();
  }
};
</script>
<style lang="scss">
.view-financial-data {
  .link {
    color: var(--dark-80) !important;
    text-decoration: underline !important;
  }
}
</style>
